import React from 'react';
import classnames from 'classnames';
import Menu from '../../../../Menu';
import { isDropdownGroup } from '../../../helpers';
import { useDropdownItems } from '../../../hooks/useDropdownItems';
import { renderMenuOption } from '../StandardMenuOption';
import { renderStandardMenuGroup } from '../StandardMenuGroup';
import s from './StandardMenuContent.scss';
var StandardMenuContent = function (_a) {
    var children = _a.children, lightText = _a.lightText, withBottomPaddings = _a.withBottomPaddings, className = _a.className, onClose = _a.onClose, onSelect = _a.onSelect, items = _a.items, groupClassName = _a.groupClassName, itemClassName = _a.itemClassName, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect;
    var filteredItems = useDropdownItems(items).filteredItems;
    return (React.createElement(Menu, { className: classnames(s['menu'], lightText && s['light-text'], !withBottomPaddings && s['without-bottom-padding'], className), onClose: onClose, onSelect: onSelect },
        filteredItems.map(function (item, idx) {
            return isDropdownGroup(item)
                ? renderStandardMenuGroup({
                    item: item,
                    className: groupClassName,
                    itemClassName: itemClassName,
                    hideCheckIcon: hideCheckIcon,
                    withHoverEffect: withHoverEffect,
                }, item.label || "item_" + idx)
                : renderMenuOption({
                    item: item,
                    className: itemClassName,
                    hideCheckIcon: hideCheckIcon,
                    withHoverEffect: withHoverEffect,
                }, item.value || "item_" + idx);
        }
        /* TODO: make Menu not suck
        (
          <StandardMenuGroup
            key={item.label || `item_${idx}`}
            item={item}
            className={groupClassName}
            itemClassName={itemClassName}
            hideCheckIcon={hideCheckIcon}
            withHoverEffect={withHoverEffect}
          />
        ) : (
          <StandardMenuOption
            key={item.value || `item_${idx}`}
            item={item}
            className={itemClassName}
            hideCheckIcon={hideCheckIcon}
            withHoverEffect={withHoverEffect}
          />
        ) */
        ),
        children));
};
StandardMenuContent.displayName = 'StandardMenuContent';
export default StandardMenuContent;
//# sourceMappingURL=StandardMenuContent.js.map